import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { formatDateForItem } from '../utils';
import { useConnectedAccount } from '../hooks/selectors';
import Transaction from './Transaction';
import { isWeb } from '../../../constants';
const strings = {
    deposit: 'Top up',
    withdraw: 'Withdrawal',
};
// Only for seccl
const OperationActivityItem = ({ item, isFirstInSection, isLastInSection, withWrapper }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const connectedAccount = useConnectedAccount();
    const { amount, timestamp, type, status } = item;
    const borderStyles = useMemo(() => [isFirstInSection && styles.firstItem, isLastInSection && styles.lastItem], [styles.firstItem, styles.lastItem, isFirstInSection, isLastInSection]);
    const onPress = useMemo(() => {
        if (status === 'pending') {
            if (type === 'deposit') {
                return () => navigation.navigate('DepositToTradingAccountTimeline', {
                    depositMethod: item.depositDetails,
                    date: timestamp,
                    amount: amount.value,
                });
            }
            if (type === 'withdraw' && connectedAccount) {
                return () => navigation.navigate('WithdrawFromAccountTimeline', {
                    date: timestamp,
                    connectedAccount,
                    amount: amount.value,
                });
            }
        }
        else if (status === 'failed') {
            if (type === 'deposit') {
                return () => navigation.navigate('DepositToTradingAccountTimeline', {
                    rejected: true,
                    date: timestamp,
                    amount: amount.value,
                    depositMethod: item.depositDetails,
                });
            }
        }
        return undefined;
    }, [amount.value, connectedAccount, item, status, timestamp, type]);
    const formattedDate = useMemo(() => {
        if (status === 'pending') {
            return undefined;
        }
        return formatDateForItem(timestamp);
    }, [status, timestamp]);
    return (<View style={[styles.wrapper, withWrapper ? borderStyles : null]}>
      <TouchableHighlight hoverOnLight onCard={isWeb} onPress={onPress} activeOpacity={1} style={withWrapper && !isWeb ? borderStyles : null} underlayColor={colors.background.underlay} disabled={onPress === undefined}>
        <Transaction status={item.status} type={type === 'deposit' ? 'DEPOSIT' : 'WITHDRAWAL'} title={item.title || strings[type]} amount={item.amount} formattedDate={formattedDate}/>
      </TouchableHighlight>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        ...(isWeb && { paddingTop: rem(8) }),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
        ...(isWeb && { paddingBottom: rem(8) }),
    },
}));
export default memo(OperationActivityItem);
